import { useContext, useState, useCallback } from "react";
import View from "views/logic/views/View";
import UserPreferencesContext from "contexts/UserPreferencesContext";
import useCurrentUser from "hooks/useCurrentUser";
import Store from "logic/local-storage/Store";
import { saveUserPreferences } from "api/preferences";
import useViewType from "views/hooks/useViewType";
const preferenceKeyMapping = {
  [View.Type.Dashboard]: "dashboardSidebarIsPinned",
  [View.Type.Search]: "searchSidebarIsPinned"
};
const _getPinningPreferenceKey = (viewType) => {
  const preferenceKey = viewType && preferenceKeyMapping[viewType];
  if (!preferenceKey) {
    throw new Error(
      `User sidebar pinning preference key is missing for view type ${viewType != null ? viewType : "(type not provided)"}`
    );
  }
  return preferenceKey;
};
const _userSidebarPinningPref = (currentUser, userPreferences, viewType) => {
  const sidebarPinningPrefKey = _getPinningPreferenceKey(viewType);
  if (currentUser == null ? void 0 : currentUser.readOnly) {
    return Store.get(sidebarPinningPrefKey);
  }
  return userPreferences[sidebarPinningPrefKey];
};
const _updateUserSidebarPinningPref = (currentUser, userPreferences, viewType, newIsPinned) => {
  const sidebarPinningPrefKey = _getPinningPreferenceKey(viewType);
  if (currentUser == null ? void 0 : currentUser.readOnly) {
    Store.set(sidebarPinningPrefKey, newIsPinned);
  } else {
    const newUserPreferences = {
      ...userPreferences,
      [sidebarPinningPrefKey]: newIsPinned
    };
    saveUserPreferences(currentUser == null ? void 0 : currentUser.username, newUserPreferences, void 0, false);
  }
};
const SearchPagePreferencesState = ({ children }) => {
  const currentUser = useCurrentUser();
  const userPreferences = useContext(UserPreferencesContext);
  const viewType = useViewType();
  const [state, setState] = useState({
    sidebarIsPinned: _userSidebarPinningPref(currentUser, userPreferences, viewType)
  });
  const _onSidebarPinningChange = useCallback(
    (newIsPinned) => _updateUserSidebarPinningPref(currentUser, userPreferences, viewType, newIsPinned),
    [currentUser, userPreferences, viewType]
  );
  const getPreference = useCallback(
    (stateKey, defaultValue) => {
      var _a;
      return (_a = state[stateKey]) != null ? _a : defaultValue;
    },
    [state]
  );
  const setPreference = useCallback(
    (stateKey, value) => {
      if (stateKey === "sidebarIsPinned") {
        _onSidebarPinningChange(value);
      }
      setState({ ...state, [stateKey]: value });
    },
    [_onSidebarPinningChange, state]
  );
  return children({ getPreference, setPreference });
};
export default SearchPagePreferencesState;
